import React from 'react';

interface StarRatingProps {
    rating: number;
    maxRating?: number;
    size?: string;
    color?: string;
}

const StarRating: React.FC<StarRatingProps> = ({ 
    rating, 
    maxRating = 5, 
    size = "24px", 
    color = "#F8C51B" 
}) => {
    // Generate stars based on rating (supports half stars)
    const renderStars = () => {
        const stars = [];
        
        for (let i = 1; i <= maxRating; i++) {
            if (i <= Math.floor(rating)) {
                // Full star
                stars.push(
                    <span 
                        key={i} 
                        style={{ 
                            color: color, 
                            fontSize: size,
                            marginRight: '2px',
                            lineHeight: 1
                        }}
                    >
                        ★
                    </span>
                );
            } else if (i === Math.ceil(rating) && rating % 1 !== 0) {
                // Half star - using a container to keep alignment
                stars.push(
                    <div 
                        key={i} 
                        style={{
                            display: 'inline-block',
                            position: 'relative',
                            width: size,
                            height: size,
                            fontSize: size,
                            marginRight: '2px',
                            lineHeight: 1,
                            verticalAlign: 'top'
                        }}
                    >
                        {/* Background empty star */}
                        <div style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            color: '#cccccc',
                            overflow: 'hidden',
                            width: '100%',
                            lineHeight: 1
                        }}>
                            ★
                        </div>
                        {/* Foreground half star */}
                        <div style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            color: color,
                            overflow: 'hidden',
                            width: '50%',
                            lineHeight: 1
                        }}>
                            ★
                        </div>
                    </div>
                );
            } else {
                // Empty star
                stars.push(
                    <span 
                        key={i} 
                        style={{ 
                            color: '#cccccc', 
                            fontSize: size,
                            marginRight: '2px',
                            lineHeight: 1
                        }}
                    >
                        ★
                    </span>
                );
            }
        }
        
        return stars;
    };

    return (
        <div className="d-flex align-items-center" style={{ lineHeight: 1 }}>
            {renderStars()}
        </div>
    );
};

export default StarRating;
